import { createFetcher } from "api/helpers"

const fetcherConfig = {
  makeRequestUrl: (host, project, params) => {
    return `${host}/security/${project}/get_key_rotation_details${
      params ? `?${params}` : ""
    }`
  },
  checkRequiredArguments: (params) => {
    if (params === undefined);
  },
  makeResponseData: (json) => {
    return json
  }
}
export default createFetcher(fetcherConfig)
